<template>
  <q-table flat bordered class="report-table" :title="title" :rows="rows" :columns="columns" :row-key="rowKey" :pagination="{ rowsPerPage: 25 }" :rows-per-page-label="$t('Rows per page')" :no-data-label="$t('reportParity.empty')" />
</template>
<script>
export default {
  name: 'ReportTable',
  props: { title: { type: String, default: '' }, rows: { type: Array, default: () => [] }, fields: { type: Array, required: true }, rowKey: { type: [String, Function], default: 'id' } },
  computed: {
    columns() {
      return this.fields.map((key) => ({ name: key, field: key, label: this.$t(`reportParity.${key}`), align: 'left', sortable: true,
        format: (value) => {
          if (value == null || value === '') return '—';
          if (typeof value === 'number' || (typeof value === 'string' && /^-?\d+(\.\d+)?$/.test(value) && !['id', 'account_id'].includes(key))) return Number(value).toLocaleString(this.$i18n.locale, { maximumFractionDigits: 2 });
          const delay = String(value).match(/^Maximum delay: (\d+) day\(s\)$/);
          if (delay) return this.$t('reportParity.delayDays', { days: delay[1] });
          const missing = String(value).match(/^order is missing (.+) billing transition$/);
          if (missing) return this.$t('reportParity.missingTransition', { state: this.$t(missing[1]) });
          if (this.$te(String(value))) return this.$t(String(value));
          const translated = `reportParity.${value}`;
          return this.$te(translated) ? this.$t(translated) : String(value);
        } }));
    },
  },
};
</script>
<style scoped>
.report-table { border-radius: 0; margin: 16px 0; }
.report-table :deep(th), .report-table :deep(td) { white-space: normal; min-width: 90px; max-width: 320px; overflow-wrap: anywhere; }
</style>
